// ============================================================
// KEDBYTE SCHOOLOS FAQ — same claims policy as schoolos.js:
// no launch date, no pricing figures, no counts, no invented
// hosting or certification claims. The data-safety answer may
// state ONLY the built guarantees. These answers also feed the
// FAQPage JSON-LD verbatim, so the policy holds there too.
// ============================================================

export const schoolosFaq = [
  {
    q: "When does SchoolOS launch?",
    a: "SchoolOS is in active development, and we don't announce launch dates. If you'd like to shape what it becomes, get in touch — we're working with a small number of schools during development.",
  },
  {
    q: "Is my school's data safe?",
    a: "Here is what is actually built, today: a child's record cannot exist without a recorded lawful basis — enforced by the database, not by policy. Every record is sealed to its school at the database level, and that isolation is tested from both directions on every table before any release. Ages are never stored — they're derived from date of birth each time, so child protections never lapse by accident. And when the system doesn't know something, it says so: missing data is a stated state, never an invented value.",
  },
  {
    q: "Who is SchoolOS for?",
    a: "Indian K-12 schools — single schools and multi-campus groups, with staff access scoped to each posting. It is being built with separate access for administrators, teachers and parents; the administrator interface is running today, and the parent portal is in progress.",
  },
  {
    q: "What will it cost?",
    a: "Pricing is announced later — we don't publish figures while the product is in development. Schools that get in touch during development hear first.",
  },
  {
    q: "What works today?",
    a: "Built and running: the data model, the security boundaries and the administrator interface. In progress: fees, attendance, examinations and the parent portal. Everything on this page is true of the product today or explicitly marked as in progress.",
  },
];
